import React, { ReactNode, useEffect } from 'react';
import { useFormState, useField, useForm } from 'react-final-form';

export type EnableWhen = {
  when: string;
  is: (value: any) => boolean;
};

type ConditionalsProps = {
  question: string;
  enableWhens?: EnableWhen[];
  enabled?: boolean;
  children: (props: { enabled?: boolean }) => ReactNode;
};

const Conditionals = ({
  question,
  enableWhens = [],
  children,
  enabled,
}: ConditionalsProps) => {
  const state = useFormState();
  const form = useForm();
  const field = useField(question, { subscription: { value: true } });
  let component = children;
  if (typeof component !== 'function') {
    throw new Error('Children must be a function');
  }

  useEffect(() => () => {
    if (!!enableWhens && enableWhens.length > 0) {
      const computed =
        enableWhens.some(x => {
          return x.is(state.values[x.when]);
        }) || !!enabled;

      if (!computed && !!field.input.value) {
        form.batch(() => form.change(question, undefined));
      }
    }
  });

  if (!!enableWhens && enableWhens.length > 0) {
    const computed =
      enableWhens.some(x => {
        return x.is(state.values[x.when]);
      }) || !!enabled;

    return <>{children({ enabled: computed })}</>;
  }

  return <>{children({})}</>;
};

export default Conditionals;
